import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import "./components/LoaderStyles.css";
import { LanguageProvider } from "./contexts/LanguageContext";

// Components
import Preloader from "./components/Preloader";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Solutions from "./components/Solutions";
import Materials from "./components/Materials";
import Partners from "./components/Partners";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

// Pages
import ImportExportPage from "./pages/ImportExportPage";
import DistributionPage from "./pages/DistributionPage";
import B2BPlatformPage from "./pages/B2BPlatformPage";
import LogisticsPage from "./pages/LogisticsPage";
import SmartBuildingPage from "./pages/SmartBuildingPage";

// Legal Pages
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import LegalNotice from "./pages/LegalNotice";

const HomePage = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3500);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <Preloader />;
  }

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <About />
      <Solutions />
      <Materials />
      <Partners />
      <Contact />
      <Footer />
      <Toaster
        position="top-right"
        richColors
        closeButton
      />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Main Pages */}
            <Route path="/" element={<HomePage />} />
            
            {/* Solutions Pages */}
            <Route path="/solutions/import-export" element={<ImportExportPage />} />
            <Route path="/solutions/distribution" element={<DistributionPage />} />
            <Route path="/solutions/b2b-platform" element={<B2BPlatformPage />} />
            <Route path="/solutions/logistics" element={<LogisticsPage />} />
            <Route path="/solutions/smart-building" element={<SmartBuildingPage />} />
            
            {/* Legal Pages */}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/legal-notice" element={<LegalNotice />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;